export default __webpack_public_path__ + "static/media/Settings.3c72759c.svg";